import * as angular from 'angular';
import * as moment from 'pkp-moment-timezone-all-years';
import { mgoAngularWizard } from '../custom';
import { DATES } from 'app/_constants/dates.constant';
import { AuctionsOverviewService } from 'app/_services/auctions-overview.service';
import { UtilService } from 'app/_services/util.service';

export enum ClockChangeType {
    NONE,
    SUMMER_WINTER,
    WINTER_SUMMER
}

class UploadWizardPricingAndAuctionSettingsComponentCtrl
    implements ng.IController
{
    public wizardCtrl: mgoAngularWizard.Wizard<any>;

    public loggedInUser: LoginResult;
    public ui: any = {};
    public requireBookedCapacity: any = false;
    public loadingCurrencies: any = true;
    public loadingCurrenciesError: any = false;
    public possibleRuntimes: any = ['RUNTIME'];
    private possiblePhysicalUnits: [string, string];
    private possibleCurrencies: any;
    public clockChange: boolean = false;
    public toDst: boolean;
    public rolloverDataErrors = [];
    public offerIdError: boolean = false;
    public offerIdErrorIndex = [];

    constructor(
        private $scope,
        private StaticData,
        private auctionsOverviewService: AuctionsOverviewService,
        private authService,
        private GENERAL_ERROR,
        private utilService: UtilService,
        private INCLUDE,
        private DATES: DATES
    ) {}

    $onInit(): void {
        this.authService.userLoginPromise.promise.then(
            (loggedInUser: LoginResult) => (this.loggedInUser = loggedInUser)
        );

        if (this.wizardCtrl.context.data.productType !== 'WITHINDAY') {
            this.possibleRuntimes.push(
                this.wizardCtrl.context.data.productType
            );
        }

        if (
            this.wizardCtrl.context.data.productType != 'DAY' &&
            this.wizardCtrl.context.data.productType != 'WITHINDAY'
        ) {
            angular.forEach(
                this.wizardCtrl.context.data.products,
                (product) => {
                    product.rolloverDataSetEnabled = false;
                    delete product.allRolloverDataSetsSelected;
                    product.rolloverDataSet = [];
                }
            );
        }

        this.StaticData.currenciesForProductUpload(
            (res) => {
                this.possibleCurrencies = res.reverse();
                this.loadingCurrencies = false;
                this.loadingCurrenciesError = false;
            },
            () => {
                this.loadingCurrencies = true;
                this.loadingCurrenciesError = true;
            }
        );

        this.init();
        this.possiblePhysicalUnits = [
            // this.wizardCtrl.context.data.selectedNetworkPoint.physicalUnit
            'K_WH_H',
            'K_WH_D'
        ];
    }

    private init() {
        angular.forEach(this.wizardCtrl.context.data.products, (product) => {
            if (!product.offerId) {
                product.offerId = this.utilService.generateGuid(2);
            }
            if (
                this.wizardCtrl.context.data.productType !== 'DAY' &&
                this.wizardCtrl.context.data.productType !== 'WITHINDAY'
            ) {
                product.priceSettingsVisible = true;
            }
            if (this.requireBookedCapacity) {
                product.auctionSettingsVisible = true;
            }
            if (
                !this.wizardCtrl.context.data.isEditMode &&
                (angular.isUndefined(product.splitFactor.value) ||
                    product.splitFactor.value == '')
            ) {
                product.splitFactor = { value: 0.5, floatingPointNumber: true };
            }

            if (this.wizardCtrl.context.data.isEditMode) {
                if (
                    this.wizardCtrl.context.data.products[0].rolloverDataSet
                        .length > 0
                ) {
                    let actualLength =
                        this.wizardCtrl.context.data.products[0].rolloverDataSet
                            .length;
                    let lengthDiffererce =
                        this.calculateRolloverDataSets(0, null, null).length -
                        actualLength;
                    if (lengthDiffererce > 0) {
                        let newStart =
                            this.wizardCtrl.context.data.products[0]
                                .rolloverDataSet[actualLength - 1].targetRuntime
                                .start;
                        let missingRollOverDataSets =
                            this.calculateRolloverDataSets(
                                0,
                                newStart,
                                actualLength
                            );
                        angular.forEach(
                            missingRollOverDataSets,
                            (missingRollOverDataSet) => {
                                this.wizardCtrl.context.data.products[0].rolloverDataSet.push(
                                    missingRollOverDataSet
                                );
                            }
                        );
                    }
                }
            }
        });
    }

    public togglePriceSettingsVisibility(index) {
        this.wizardCtrl.context.data.products[index].priceSettingsVisible =
            !this.wizardCtrl.context.data.products[index].priceSettingsVisible;
    }

    public toggleAuctionSettingsVisibility(index) {
        this.wizardCtrl.context.data.products[index].auctionSettingsVisible =
            !this.wizardCtrl.context.data.products[index]
                .auctionSettingsVisible;
    }

    public toggleRolloverSetVisibility(index) {
        this.wizardCtrl.context.data.products[index].rolloverSetVisible =
            !this.wizardCtrl.context.data.products[index].rolloverSetVisible;
    }

    public isLongTerm(name) {
        var periodTypeByValue =
            this.auctionsOverviewService.getPeriodTypeByValue(name);
        if (this.auctionsOverviewService.isLongTermAuction(periodTypeByValue)) {
            return true;
        }
        return false;
    }

    public generateCalculatedRolloverDataSets(index, update, enabled) {
        this.wizardCtrl.context.data.products[index].rolloverDataSetEnabled =
            enabled;
        if (
            this.wizardCtrl.context.data.products[index]
                .rolloverDataSetEnabled &&
            !update
        ) {
            this.wizardCtrl.context.data.products[
                index
            ].allRolloverDataSetsSelected = false;
            this.wizardCtrl.context.data.products[index].rolloverDataSet =
                this.calculateRolloverDataSets(index, null, null);
        } else if (
            this.wizardCtrl.context.data.products[index]
                .rolloverDataSetEnabled &&
            update
        ) {
            var i = 0;
            angular.forEach(
                this.wizardCtrl.context.data.products[index].rolloverDataSet,
                (dataset) => {
                    dataset.offerId =
                        this.wizardCtrl.context.data.products[index].offerId +
                        (i + 1);
                    dataset.regulatedCapacityTariff = angular.copy(
                        this.wizardCtrl.context.data.products[index]
                            .regulatedCapacityTariff
                    );
                    dataset.startingPrice = angular.copy(
                        this.wizardCtrl.context.data.products[index]
                            .startingPrice
                    );
                    dataset.balancingCharge = angular.copy(
                        this.wizardCtrl.context.data.products[index]
                            .balancingCharge
                    );
                    dataset.commodityFee = angular.copy(
                        this.wizardCtrl.context.data.products[index]
                            .commodityFee
                    );
                    i++;
                }
            );
        } else {
            delete this.wizardCtrl.context.data.products[index].rolloverDataSet;
        }
    }

    public calculateRolloverDataSets(index, overrideStart, overrideCount): any {
        let start;

        if (!!overrideStart) {
            start = moment(overrideStart).add(1, 'hours');
        } else {
            start = moment(this.wizardCtrl.context.data.runtime.start);
        }
        let end = moment(this.wizardCtrl.context.data.runtime.end);

        let calculatedRolloverDataSets = [];

        let rolloverStart = moment(start);
        if (
            this.wizardCtrl.context.data.productType === 'WITHINDAY' &&
            !overrideStart
        ) {
            rolloverStart.add(1, 'hours');
        }
        let i = overrideCount || 0;
        for (; rolloverStart.isBefore(end); rolloverStart.add(1, 'hours')) {
            let rolloverDataSet = {
                selected: false,
                targetRuntime: {
                    start: rolloverStart.toISOString(),
                    end: end.toISOString()
                },
                offerId:
                    this.wizardCtrl.context.data.products[index].offerId +
                    (i + 1),
                regulatedCapacityTariff: angular.copy(
                    this.wizardCtrl.context.data.products[index]
                        .regulatedCapacityTariff
                ),
                startingPrice: angular.copy(
                    this.wizardCtrl.context.data.products[index].startingPrice
                ),
                balancingCharge: angular.copy(
                    this.wizardCtrl.context.data.products[index].balancingCharge
                ),
                commodityFee: angular.copy(
                    this.wizardCtrl.context.data.products[index].commodityFee
                )
            };
            calculatedRolloverDataSets.push(rolloverDataSet);
            i++;
        }

        return calculatedRolloverDataSets;
    }

    public getClockChangeType(): ClockChangeType {
        let startTimeIsDst: boolean = moment(
            this.wizardCtrl.context.data.runtime.start
        )
            .tz('Europe/Brussels')
            .isDST();
        let endTimeIsDst: boolean = moment(
            this.wizardCtrl.context.data.runtime.end
        )
            .tz('Europe/Brussels')
            .isDST();

        if (startTimeIsDst === endTimeIsDst) {
            return ClockChangeType.NONE;
        } else if (!startTimeIsDst && endTimeIsDst) {
            return ClockChangeType.WINTER_SUMMER;
        } else {
            return ClockChangeType.SUMMER_WINTER;
        }
    }

    public getClockChangeTypeEnumValue(name: string) {
        return ClockChangeType[name];
    }

    public selectAllRolloverDataSets(index) {
        for (
            var i = 0;
            i <
            this.wizardCtrl.context.data.products[index].rolloverDataSet.length;
            i++
        ) {
            this.wizardCtrl.context.data.products[index].rolloverDataSet[
                i
            ].selected =
                this.wizardCtrl.context.data.products[
                    index
                ].allRolloverDataSetsSelected;
        }
    }

    public checkConsecutivenessOfRolloverDataSets(
        productIndex: number
    ): boolean {
        const rolloverDataSet =
            this.wizardCtrl.context.data.products[productIndex].rolloverDataSet;

        if (!rolloverDataSet[0].selected) {
            this.rolloverDataErrors[productIndex] = true;
            return !this.rolloverDataErrors[productIndex];
        }

        const selectedRolloverDataSetIndices = rolloverDataSet
            .filter((val) => val.selected)
            .map((val) => rolloverDataSet.indexOf(val));

        let i;
        for (i = 1; i < selectedRolloverDataSetIndices.length; i++) {
            const isConsecutiveIndex =
                selectedRolloverDataSetIndices[i] -
                    selectedRolloverDataSetIndices[i - 1] ===
                1;

            if (!isConsecutiveIndex) {
                this.rolloverDataErrors[productIndex] = true;
                return !this.rolloverDataErrors[productIndex];
            }
        }

        this.rolloverDataErrors[productIndex] = false;
        return !this.rolloverDataErrors[productIndex];
    }

    public validateUniqueOfferId(index) {
        this.offerIdError = false;
        this.offerIdErrorIndex = [];

        for (let productToCheck of this.wizardCtrl.context.data.products) {
            let offerId = productToCheck.offerId;
            //check current products
            //it is already in there so the count should be = 1
            let count = 0;
            for (let product of this.wizardCtrl.context.data.products) {
                if (product.offerId == offerId) {
                    count++;
                }
            }

            if (count > 1) {
                this.offerIdError = true;
                this.offerIdErrorIndex.push(index);
                // return false;
            }

            //check transferdata products if available
            if (this.wizardCtrl.context.transferData) {
                for (let productSet of this.wizardCtrl.context.transferData) {
                    //check for editing product from transfer data
                    if (
                        this.wizardCtrl.context.data.wizardGuid !==
                        productSet.wizardGuid
                    ) {
                        for (let product of productSet.products) {
                            if (product.offerId == offerId) {
                                this.offerIdError = true;
                                this.offerIdErrorIndex.push(index);
                                // return false;
                            }
                        }
                    }
                }
            }
        }
    }

    //Remove fields from JSON that are not filled
    public checkRemove(index, fieldValue, fieldName) {
        if (fieldValue.originalValue.value == null) {
            delete this.wizardCtrl.context.data.products[index][fieldName];
        } else {
            this.wizardCtrl.context.data.products[index][fieldName] =
                fieldValue;
        }
    }

    public submit(isValid): boolean {
        if (!isValid) {
            return false;
        }

        this.wizardCtrl.next();
        return true;
    }
}

angular
    .module('app')
    .component('pkpProductUploadWizardPricingAndAuctionSettings', {
        controller: UploadWizardPricingAndAuctionSettingsComponentCtrl,
        template:
            require('app/product-upload-wizard/product-upload-wizard-pricing-and-auction-settings.component.html'),
        require: {
            wizardCtrl: '^^wizard'
        },
        bindings: {}
    });
